module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pgemnt-1"
  }, [_c('div', {
    staticClass: "tbs"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.postList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "角色名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属机构",
      "prop": "organizationName",
      "width": "145"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("filterStatus")(scope.row.status )) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "left",
      "width": "240",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.deleteDTO(scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-1963b4b3"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/pgment/rule/list/ruleList.vue
// module id = 1422
// module chunks = 1